import { makeAutoObservable, observable  } from "mobx";

import { getCurrentUser } from "../../../Utility/modules/helpers";
import { menuService } from "../services/menuService";
class MainStore {
  constructor() {
    makeAutoObservable(this);
  }

  ismenuLoading = false;
  showContextDialog = false;
  assetContextId = getCurrentUser()?.userPreference.assetContextId ?? 1;
  defaultEquity = 20;
  assetContextName = getCurrentUser()?.userPreference.assetContext ?? "NAOC";
  assets = observable.map({});
  showSettingsDialog = false;
  showProductionManagementGlobalLinkDialog = false;
  showTechnicalGlobalLinkDialog = false;
  menuSelectedKey = "1010";
  menuOpenKey = "24";
  async fetchAppMenu() {
    this.ismenuLoading = true;
    try {
      const res = await menuService.getAppMenu();
      return res;
    } catch (error) {
      throw error;
    }
  }

  async fetchAssets() {
    try {
      let res = [];
      res = await menuService.getAssets();
      this.assets.clear();
      res.forEach((a) => {
        this.assets.set(a.assetId, {
          ...a,
          name: a.assetName,
          value: a.assetId,
        });
      });
    } catch (error) {
      throw error;
    }
  }

  async resetPassword(email) {
    try {
      const res = await menuService.resetPassword(email);
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    }
  }
  resetAssetContext() {
    this.assetContextId = 1;
    this.assetContextName = "NAOC";
  }
}


const mainStore = new MainStore();
export default mainStore; // createContext(new MainStore());

